import { CheckIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { cn } from '@/lib/utils'

import { type DocumentData } from './types'

export interface DocumentButtonProps {
  item: DocumentData
  onClick: VoidFunction
}

export const DocumentButton = forwardRef<HTMLButtonElement, DocumentButtonProps>((props, ref) => {
  const { item, onClick, ...restProps } = props
  const { name, isActive, isReviewed } = item

  return (
    <button
      ref={ref}
      {...restProps}
      type="button"
      className={cn('flex items-center gap-x-1.5', 'w-full', 'rounded-[8px]', 'p-2.5', 'text-xs font-semibold', {
        'bg-slate-200': isActive && !isReviewed,
        'hover:bg-slate-200': !isActive && !isReviewed,
        'bg-blue-100 text-blue-600': isReviewed,
      })}
      onClick={onClick}
    >
      <CheckIcon
        size={16}
        className={cn('min-w-4', {
          'text-slate-400': (isActive && !isReviewed) || !isActive,
          'text-blue-600': isReviewed,
        })}
      />
      <span className={cn('w-full', 'text-ellipsis text-left', { 'text-black': isActive && !isReviewed })}>{name}</span>
    </button>
  )
})
DocumentButton.displayName = 'DocumentButton'
